import { render, staticRenderFns } from "./HistoryExam.vue?vue&type=template&id=20cbc582"
import script from "./HistoryExam.vue?vue&type=script&lang=js"
export * from "./HistoryExam.vue?vue&type=script&lang=js"
import style0 from "./HistoryExam.vue?vue&type=style&index=0&id=20cbc582&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports